import { Outlet } from "react-router-dom";
import { useEffect } from "react";

import { sessionActions } from "../redux/reducers/sessionSlice";
import { useAppDispatch, useAppSelector } from "../redux";
import { View } from "../components/base";
import { consumePostAuthReturnUrl } from "../utils/postAuthRedirect";

export const AppLayout = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.session.user);
  const isLoadingSession = useAppSelector((state) => state.session.isLoadingSession);

  useEffect(() => {
    dispatch(sessionActions.getSession());
  }, []);

  // OAuth (Google) lands back on the app root and drops the ?returnUrl. Once the
  // session is established, replay the returnUrl we stashed before leaving so the
  // user returns to where they started (e.g. the CLI approval page).
  useEffect(() => {
    if (isLoadingSession || !user) return;
    consumePostAuthReturnUrl();
  }, [user, isLoadingSession]);

  return (
    <View className="w-full h-full bg-white dark:bg-gray-900 overflow-auto">
      <Outlet />
    </View>
  );
};
